import { AnneeFormationSuivieIfapmeDetail } from "./AnneeFormationSuivieIfapmeDetail";
import { DiplomeCertificationIfapmeDetail } from "./DiplomeCertificationIfapmeDetail";
import * as React from "react";
export interface IAcquisScolaireGlobalIfapmeProps {
  idpersonne: number;
  listRoute: string;
}

export const AcquisScolaireGlobalIfapme: React.FunctionComponent<IAcquisScolaireGlobalIfapmeProps> = ({
  idpersonne,
  listRoute
}) => {
  const [typeAcquisForm, SetTypeAcquisForm] = React.useState("DiplomeCertification");
  const changeFormType = React.useMemo(() => {
    switch (typeAcquisForm) {
      case "AnneeFormationSuivie":
        return (
          <AnneeFormationSuivieIfapmeDetail
            onTypeAcquisChange={SetTypeAcquisForm}
            idpersonne={idpersonne}
            listRoute={listRoute}
          />
        );
      case "DiplomeCertification":
        return (
          <DiplomeCertificationIfapmeDetail
            onTypeAcquisChange={SetTypeAcquisForm}
            idpersonne={idpersonne}
            listRoute={listRoute}
          />
        );
      default:
        return (
          <AnneeFormationSuivieIfapmeDetail
            onTypeAcquisChange={SetTypeAcquisForm}
            idpersonne={idpersonne}
            listRoute={listRoute}
          />
        );
    }
  }, [idpersonne, listRoute, typeAcquisForm]);

  return <>{changeFormType}</>;
};
